// extracted by mini-css-extract-plugin
module.exports = {"SectionCategories":"ROflm","SectionCategoriesCard__Slider":"_2bZ8c","SectionCategories__Card":"kimJF"};